import getFabricEvents from './fabricEvents';
import colonsToCamelCase from './colonsToCamelCase';
import debounce from 'lodash.debounce';

/*
* Remaps fabric events to component events.
*
* Fabric events come in comma separated strings, e.g. `object:added`,
* instead, for consistency for the Vue ecosystem, we convert them to
* camel case event names (e.g. `objectAdded`).
*
* @param  {fabric.Canvas}  canvas  The fabric canvas instance.
* @param  {VueComponent}  component  The Vue component instance.
* @param  {Array}  events  A list of strings of fabric event names.
*
* @return  void
*/
const eventRemap = function( canvas, component, events = getFabricEvents() ) {
   events.forEach((e) => {
      canvas.on(e, (opts) => {
         //console.log('eventName ' + e + " " + opts.target);
         if(e=="object:added") {
            //console.log('type ' + e + " " + opts.target.type);
            if(component.isDrawingMode && (opts.target.type === 'path' || opts.target.type === 'group'))
            {
               console.log('object:added - type ' + e + " " + opts.target.type);
               //console.log('type ' + e + " " + opts.target.type);
               //console.log('eventName ' + e + " " + opts.target);
                  opts.target.set('selectable', false);
                  opts.target.set('evented', false);
                  opts.target.set('perPixelTargetFind', true);

                  if (opts.target.type === 'path') {
                     // fix bug that moves the path when created
                     //opts.target.set('top', opts.target.get('top')+canvas.freeDrawingBrush.width * 0.5);
                     //opts.target.set('left', opts.target.get('left')+canvas.freeDrawingBrush.width * 0.5);
                  }

               var canvas_objects = canvas._objects;
               var last = canvas_objects[canvas_objects.length -1]; //Get last object
               console.log('last ' + last);
               component.pathObjects.push(last);
               component.$emit('enableUndo', true);
            }
         }
         // else if(e=="path:created") {
         //    if(component.isDrawingMode)// || opts.target.type === 'group')
         //    {
         //       //console.log('type ' + e + " " + opts.target.type);
         //       //console.log('eventName ' + e + " " + opts.target);
         //          // e.path.set('selectable', false);
         //          // e.path.set('evented', false);
         //          // e.path.set('perPixelTargetFind', true);
         //
         //       //}
         //       // fix bug that moves the path when created
         //       //var canvas_objects = canvas._objects;
         //       //var last = canvas_objects[canvas_objects.length -1]; //Get last object
         //       //component.pathObjects.push(e.path);
         //       //component.$emit('enableUndo', true);
         //    }
         // }
         else if (e=="selection:created" ) {
            console.log('selection:created ' + " " + opts.target);
            component.$emit('somethingSelected', true);
         }
         else if (e=="selection:cleared" ) {
            console.log('selection:cleared ' + " " + opts.target);
            component.$emit('somethingSelected', false);
         }

         else if (e=="mouse:down") {
            //console.log('eventName ' + e + " " + canvas.getActiveObject());
            if (canvas.getActiveObject() != null || canvas.isDrawingMode)
            {
               component.$emit('isUserInactive', false);
               // if(component.os == 'Android')
               if(component.isVideoTimerActive)
                   component.pauseVideoTimer();
               //component.isVideoTimerActive = false;
            }
         }
         else if (e=="mouse:up") {
            component.$emit('isUserInactive', true);
            //component.isVideoTimerActive = true;
            // if(component.os == 'Android')
            if(component.isVideoTimerActive)
                component.playVideoTimerWithDelay();
         }
         else if (e=="mouse:move") {}
         else if (e=="mouse:over") {}
         else if (e=="mouse:out") {}
         else if (e=="object:moving") {
            if(!component.isObjDragging)
            {
               component.isObjDragging = true;
            }
            var pointer = canvas.getPointer();
            component.$emit('isObjectDragging', true, pointer.x, pointer.y);
            // if(component.os == 'Android')
            //component.isVideoTimerActive = false;
            if(component.isVideoTimerActive)
                component.pauseVideoTimer();
         }
         else if (e=="object:modified") {
            //console.log('object:modified ' + opts.target.top);
            if(component.isObjDragging)
            {
               component.isObjDragging = false;
               var pointer = canvas.getPointer();
               component.$emit('isObjectDragging', false, pointer.x, pointer.y);
            //    if(component.os == 'Android')
            if(component.isVideoTimerActive)
                   component.playVideoTimerWithDelay();
            //component.isVideoTimerActive = true;
             }
         }
         // else if (e=="object:scaling") {
         //   console.log('object:scaling ' + opts.target.top);
         //   if (opts.target.scaleX > target.maxScaleLimit) {
         //      target.scaleX =  target.maxScaleLimit;
         //   }
         //   if (opts.target.scaleY > target.maxScaleLimit) {
         //      target.scaleY =  target.maxScaleLimit;
         //   }

         else
         {
            //console.log('uncatch eventName ' + e + " " + opts.target);
            //opts.target.uniScaleTransform = true;
         }
         let eventName = colonsToCamelCase(e);
         component.$emit(eventName, opts);
      });
   });
}

/*
* Initializes the Fabric canvas inside a Vue component.
*
* @param  {VueComponent}  component The Vue component instance.
* @param  {String}  [namespace='Canvas']  The name of the canvas instance.
* Useful if the original fabric Canvas class was extended by some other class.
*/
const init = function(component, namespace = 'Canvas') {
   //   const canvas = new fabric[namespace](component.$el, {
   fabric.Object.prototype.maxScaleLimit = 10;
   const canvas = new fabric[namespace](component.id, {
      // Disabling this for performance reason: we load the entire canvas
      // every time and perform the render manually instead
      //renderOnAddRemove: false,
      //isDrawingMode: true,
      selection: false,
      width: component.message_width,
      height: component.message_height,
      enableRetinaScaling: component.is_retina,
      preserveObjectStacking: true,
      uniScaleTransform: false,
      targetFindTolerance: 15,
      objectCaching: true,
      statefullCache: false,
      noScaleCache: true
      //enablePointerEvents:true // bug au zoom si true


      //backgroundColor: 'rgb(255, 73, 64)',
      //backgroundImage: "http://placehold.it/500x200/448844/fff"
   });

   //console.log("fabric.isTouchSupported " + fabric.isTouchSupported);
   console.log("fabric canvas w: " + canvas.width + ", h: " + canvas.height);
   //fabric.isTouchSupported = true;
   //console.log("fabric.isTouchSupported " + fabric.isTouchSupported);

   var imageOffsetX, imageOffsetY;

   var canvasObject = document.getElementById(component.id);
   console.log("html canvas w: " + canvasObject.width + ", h: " + canvasObject.height);
   var dragImage = document.getElementById('sticker-clone-img');

   var startingX = 0;
   var startingY = 0;

   var xCoordinate = 0;
   var yCoordinate = 0;


   var delta2PosMin = 200; // déplacement mini
   var delta2Pos = 0;
   var oldX = 0;
   var oldY = 0;




   function handleDragStart(e) {
      console.log('start drag event: ', e);

      [].forEach.call(images, function (img) {
         img.classList.remove('img_dragging');
      });
      this.classList.add('img_dragging');

      console.log('this.classList.: ', this.classList);

      //var imageOffset = $(this).offset();
      delta2Pos = 0;
      imageOffsetX = e.clientX; //- e.offsetLeft;
      imageOffsetY = e.clientY; //- e.offsetTop;

      var rect = e.target.getBoundingClientRect();


      if(e.touches == null) {
         xCoordinate = (e.clientX - rect.left) * 1.5;
         yCoordinate = (e.clientY - rect.top) * 1.5;
         if (component.isUserInactive) {
            component.isUserInactive = false;
            component.$emit('isUserInactive', false);
         }
      }
      else { //manual drag and drop for touch events
         // clone image instead
         dragImage.src = e.target.src;

         xCoordinate = (e.touches[0].clientX - rect.left) * 1.5;
         yCoordinate = (e.touches[0].clientY - rect.top) * 1.5;
         //console.log("coord " + xCoordinate + " " + yCoordinate);

         var touch = e.touches[0];
         startingX = oldX = e.touches[0].pageX;
         startingY = oldY = e.touches[0].pageY;
         //console.log("start touches x y " + startingX + " " + startingY);
         dragImage.style.display = 'inline';
         moveDragImage(touch.pageX, touch.pageY);
      }
   }

   function moveDragImage(x, y) {

      var x = x -  xCoordinate;// - dragImage.width*0.5;
      var y = y -  yCoordinate;// - dragImage.height*0.5;

      dragImage.style.left =  x + 'px';
      dragImage.style.top =  y + 'px';

   }

   function handleTouchMove(e) {
      var touch = e.touches[0];
      delta2Pos += (touch.pageX - oldX) * (touch.pageX - oldX) + (touch.pageY - oldY) * (touch.pageY - oldY);
      moveDragImage(touch.pageX, touch.pageY);
      oldX = touch.pageX;
      oldY = touch.pageY;
      if (delta2Pos > delta2PosMin && component.isUserInactive) {
         component.isUserInactive = false;
         component.$emit('isUserInactive', false);
      }

      //dragImage.style.display = 'inline';
   }



   function handleDragOver(e) {
      if (e.preventDefault) {
         e.preventDefault();
      }
      e.dataTransfer.dropEffect = 'copy';
      return false;
   }

   function handleDragEnter(e) {
      this.classList.add('over');
   }

   function handleDragLeave(e) {
      this.classList.remove('over');
   }

   function handleDrop(e) {
      console.log('handleDrop event: ', e);
      // On mobile this turns on default page scrolling after the end of a drag drop.
      //$(document).off('touchstart');

      e = e || window.event;
      if (e.preventDefault) {
         e.preventDefault();
      }
      if (e.stopPropagation) {
         e.stopPropagation();
      }
      var y = e.clientY - yCoordinate; // - img.naturalHeight * 0.125;
      var x = e.clientX - xCoordinate; // - img.naturalWidth * 0.125;
      //console.log("handleDrop ");
      addImage(x,y);
      return false;
   }

   function handleDragEnd(e) {
      console.log('handleDragEnd event: ', e);

      [].forEach.call(images, function (img) {
         img.classList.remove('img_dragging');
      });
      component.$emit('endDrop');
      component.isUserInactive = true;
      component.$emit('isUserInactive', true);
   }

   function handleTouchEnd(e) {
      console.log('handleTouchEnd event: ', e);
      e.preventDefault();
      e.stopPropagation();
      dragImage.style.display = 'none';
      var changedTouch = event.changedTouches[0];
      var endTarget = document.elementFromPoint(changedTouch.clientX, changedTouch.clientY);

      console.log("endTarget " + endTarget);
      var x = changedTouch.pageX - endTarget.offsetLeft - xCoordinate;
      var y = changedTouch.pageY - endTarget.offsetTop - yCoordinate;

      console.log("endTarget x y " + x + " " + y);
      // if (delta2Pos > delta2PosMin)
      // {
      //    component.isUserInactive = true;
      //    component.$emit('isUserInactive', true);
      //    addImage(x,y);
      // }

      addImage(x,y);
      handleDragEnd(e);
      return false;
   }


   function addImage(x,y) {

      var img = document.querySelector('.stickersDiapo img.img_dragging');
      img.crossOrigin = "Anonymous";  // This enables CORS
      console.log("add img size " + img.naturalWidth + " " + img.naturalHeight);
      var isLoaded = img.complete && img.naturalHeight !== 0;
      if(isLoaded) {
         addLoadedImage(img,x,y);
      }
      else {
         img.onload  = function(){
            addLoadedImage(img,x,y);
            }
         }
   }

   function addLoadedImage(img,x,y) {
         //var img2 = document.querySelector('.stickersDiapo img.img_dragging');
         console.log("loaded img size " + img.naturalWidth + " " + img.naturalHeight);

         var comp = component;
         var newImage = new fabric.Image(img, {
            width: img.naturalWidth,
            height: img.naturalHeight,
            left: x / comp.messageReduction,
            top: y / comp.messageReduction,
            //scaleX: 1.0,
            //scaleY: 1.0,
            scaleX: 150/img.naturalWidth * comp.menuScale,
            scaleY: 150/img.naturalWidth * comp.menuScale,
            //minScaleLimit:0.25 * comp.menuScale,
            minScaleLimit:0.7 * 150/img.naturalWidth * comp.menuScale,
            lockUniScaling: true,
            hasBorders: false,
            hasControls: false,
            hasRotatingPoint: false,
            perPixelTargetFind:true // pb avec resize gestures

         });
         console.log("size " + newImage.width + " " + newImage.height);
         console.log("scale " + newImage.scaleX + " " + newImage.scaleY);
         //console.log("messageReduction " + comp.messageReduction);
         //newImage.setShadow({ color: 'rgba(0,0,0,0.)', blur: 50 });
         canvas.add(newImage);
         component.canvasObjects.push(newImage);
         // newImage.on(("mousedown"),function(){
         //    //console.log("image clicked " + this.isSelected);
         //    //this.canvas.renderAll();
         //    if (this.isSelected){
         //       this.isSelected = false;
         //       canv.discardActiveObject();
         // }
         // });
         newImage.on(("selected"),function(){
            //left = this.textBox.left;
            //console.log("image selected");
            var that = this;
            var timeout = setTimeout(function(){
               that.isSelected = true;
            }, 10)

            this.bringToFront();
            this.perPixelTargetFind = false;
            //this.setShadow({ color: 'rgba(0,0,0,0.7)', blur: 50 });

         });
         var canv = canvas;
         newImage.on(("deselected"),function(){
            //left = this.textBox.left;
            //console.log("image deselected");
            this.isSelected = false;
            this.perPixelTargetFind = true;
            //this.setShadow({ color: 'rgba(0,0,0,0.', blur: 50 });
            this.canvas.renderAll();
         });

         // select the image when created
         //canv.setActiveObject(newImage);

   }


   var images = document.querySelectorAll('.stickersDiapo img');
   [].forEach.call(images, function (img) {
      img.addEventListener('dragstart', handleDragStart, false);
      img.addEventListener('dragend', handleDragEnd, false);
      //img.addEventListener('mousedown', handleDragStart, false);
      //img.addEventListener('mouseup', handleDragEnd, false);
      img.addEventListener('touchstart', handleDragStart, false);
      img.addEventListener('touchmove', handleTouchMove, false);
      img.addEventListener('touchend', handleTouchEnd, false);
   });

   // var canvasContainer = document.getElementById('message-creator');
   var canvasContainer = component.$refs.messagecreator;
   canvasContainer.addEventListener('dragenter', handleDragEnter, false);
   canvasContainer.addEventListener('dragover', handleDragOver, false);
   canvasContainer.addEventListener('dragleave', handleDragLeave, false);
   canvasContainer.addEventListener('drop', handleDrop, false);





   component.$canvas = canvas;

   eventRemap(canvas, component);

   canvas.loadFromJSON( component.value, canvas.renderAll.bind(canvas) );

   canvas.on('after:render', debounce(() => { component.syncCanvas(); }, 100) );
}

export default init;
